﻿class Human {
    constructor() {
        this.revealed = false;
        this.events = 0;
        this.formInputs = [];

        var scrolled = function () {
            //console.log("scroll");
            this.events++;
            this.reveal();
            document.removeEventListener("scroll", scrolled)
        }.bind(this);
        document.addEventListener("scroll", scrolled);

        var moused = function () {
            //console.log("moused");
            this.events++;
            this.reveal();
            document.removeEventListener("mouseover", moused)
        }.bind(this);
        document.addEventListener("mouseover", moused);

        var touched = function () {
            //console.log("touched");
            this.events++;
            this.reveal();
            document.removeEventListener("touchstart", touched)
        }.bind(this);
        document.addEventListener("touchstart", touched);

        var keyed = function () {
            //console.log("keyed");
            this.events++;
            this.reveal();
            document.removeEventListener("keydown", keyed)
        }.bind(this);
        document.addEventListener("keydown", keyed);

        document.querySelectorAll('form').forEach(function (form) {
            var input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", "_hpts");
            input.setAttribute("value", "0");
            form.appendChild(input);
            this.formInputs.push(input);
        }.bind(this));
    }

    reveal() {
        if (!this.revealed && this.events >= 2) {
            //console.log('reveal');

            document.querySelectorAll('.reveal-phone').forEach(function(tel) {
                tel.setAttribute('href', atob("dGVsOis0NTI1MzY2MzQ0"));
                tel.innerHTML = atob("MjUgMzYgNjMgNDQ=");
            })

            document.querySelectorAll('.reveal-mail').forEach(function (mail) {
                mail.setAttribute('href', atob("bWFpbHRvOnNpbW9uQGJpdHZhZXJrLmRr"));
                mail.innerHTML = atob("c2ltb25AYml0dmFlcmsuZGs=");
            });

            this.revealed = true;
        }

        this.formInputs.forEach(function (input) {
            input.setAttribute("value", this.events);
        }.bind(this));

    }
}


window.addEventListener('DOMContentLoaded', (e) => {
    var human = new Human();
});